import React from 'react';
import PropTypes from 'prop-types';

import {Stack, TextField, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

const SkillsNewPrompt = (props) => {
  const {prompt, setParameters, setPrompt} = props;

  React.useEffect(() => {
    const autoParameterNamePattern = /^(client|caregiver|requester)[A-Za-z0-9_-]*$/i;
    const promptParameterPattern = /\{\{\s*((client|caregiver|requester)[A-Za-z0-9_-]*)(?=\s*(?:\.|\}\}))/gi;
    const promptParameterType = {
      client: 'CLIENT',
      caregiver: 'CAREGIVER',
      requester: 'USER',
    };
    const promptParameters = [];
    const seenNames = new Set();

    Array.from(prompt.matchAll(promptParameterPattern)).forEach((match) => {
      const name = match[1];
      const type = promptParameterType[match[2]?.toLowerCase()];

      if (!name || !type || seenNames.has(name)) {
        return;
      }

      seenNames.add(name);
      promptParameters.push({
        name,
        type,
      });
    });

    setParameters((currentParameters = []) => {
      const nextParameters = [
        ...currentParameters.filter(
            (parameter) => !autoParameterNamePattern.test(parameter?.name || ''),
        ),
        ...promptParameters,
      ];

      if (JSON.stringify(nextParameters) === JSON.stringify(currentParameters)) {
        return currentParameters;
      }

      return nextParameters;
    });
  }, [prompt, setParameters]);

  return (
    <Stack sx={{gap: '8px'}}>
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 600,
          color: '#A8A49E',
          lineHeight: '100%',
          textTransform: 'uppercase',
        }}
      >
        <Translate expression='skills.skills.New.InstructionsLabel' />
      </Typography>
      <TextField
        value={prompt}
        onChange={setPrompt}
        placeholder={translate('skills.skills.New.InstructionsPlaceholder')}
        multiline
        minRows={5}
        sx={{
          '& .MuiOutlinedInput-root': {
            'borderRadius': '12px',
            'backgroundColor': '#FFFFFF',
            'alignItems': 'flex-start',
          },
          '& .MuiOutlinedInput-input': {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '150%',
            color: '#1A1916',
            boxSizing: 'border-box',
          },
          '& .MuiOutlinedInput-input::placeholder': {
            color: '#A8A49E',
            opacity: 1,
            whiteSpace: 'pre-line',
          },
        }}
      />
    </Stack>
  );
};

SkillsNewPrompt.propTypes = {
  prompt: PropTypes.string.isRequired,
  setParameters: PropTypes.func.isRequired,
  setPrompt: PropTypes.func.isRequired,
};

export default React.memo(SkillsNewPrompt);
